import { useGetProtection } from '@pa/api/admin'
import type { ProtectionSearch } from '../model/search'
import { ProtectionForm } from './ProtectionForm'
import { SecurityEvents } from './SecurityEvents'

export interface ProtectionTabProps {
  clinicId: string
  /** The clinic's zone: times and date presets (Frontend §7.1). */
  timeZone: string
  search: ProtectionSearch
  onSearch: (next: ProtectionSearch, opts?: { replace?: boolean }) => void
}

/**
 * S-04 **Protection** (UserFlows S-04; Frontend §7.2; D-37): the clinic's abuse settings (#54 / #55) and the read-only
 * list of recent security events (#56). Super Admin only (the server's policy).
 */
export function ProtectionTab({ clinicId, timeZone, search, onSearch }: ProtectionTabProps) {
  const query = useGetProtection(clinicId, { query: { staleTime: 30_000 } })
  return (
    <div className="protection-tab">
      {query.isPending ? (
        <div className="card card-pad" role="status">
          Loading the protection settings…
        </div>
      ) : query.isError ? (
        <div className="card card-pad" role="alert">
          Couldn&apos;t load the protection settings.{' '}
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => void query.refetch()}>
            Retry
          </button>
        </div>
      ) : (
        <ProtectionForm
          key={query.data.updatedAt ?? 'defaults'}
          clinicId={clinicId}
          timeZone={timeZone}
          settings={query.data}
        />
      )}
      <SecurityEvents clinicId={clinicId} timeZone={timeZone} search={search} onSearch={onSearch} />
    </div>
  )
}
